function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#279181;}.b{fill:#ff5736;}.c{fill:#4cd6d6;}.d{fill:#fdaa2c;}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M164.559,288.395a1.2,1.2,0,0,0-1.788.017l-6.836,7.768a1.2,1.2,0,0,0,0,1.587l6.836,7.768a1.2,1.2,0,0,0,1.788.017l7.106-7.768a1.2,1.2,0,0,0,0-1.622Z",
  transform: "translate(-143.173 -264.942)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M155.8,0A4.914,4.914,0,0,0,151,5.15c0,3.585,3.312,5.8,7.617,9.567a1.2,1.2,0,0,0,1.582,0c4.3-3.767,7.617-5.982,7.617-9.567A4.914,4.914,0,0,0,163.012,0a4.493,4.493,0,0,0-3.6,1.81A4.493,4.493,0,0,0,155.8,0Z",
  transform: "translate(-138.908)"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M12.012,138.414a4.8,4.8,0,0,0,1.2-9.458,4.8,4.8,0,1,0-9.6,0,4.8,4.8,0,1,0,3.6,8.812v3.048h-1.2a1.2,1.2,0,1,0,0,2.4h4.8a1.2,1.2,0,1,0,0-2.4h-1.2v-3.048A4.774,4.774,0,0,0,12.012,138.414Z",
  transform: "translate(0 -114.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M311.2,120.548a1.2,1.2,0,0,0-1.582,0c-4.3,3.767-7.617,5.982-7.617,9.567a4.914,4.914,0,0,0,4.8,5.15,4.342,4.342,0,0,0,2.4-.7v2.805h-1.2a1.2,1.2,0,1,0,0,2.4h4.8a1.2,1.2,0,0,0,0-2.4h-1.2v-2.805a4.341,4.341,0,0,0,2.4.7,4.914,4.914,0,0,0,4.8-5.15C318.816,126.53,315.5,124.315,311.2,120.548Z",
  transform: "translate(-277.817 -110.622)"
}));

const SvgPoker = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 41,
  viewBox: "0 0 41 41",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPoker, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/poker.a0a21726.svg";
export { ForwardRef as ReactComponent };